export function convertKgTolbs(kgs: number): number {
  const highPrecisionPounds = kgs / 0.45359237;
  const roundedPounds = Math.round(highPrecisionPounds * 100) / 100;
  return roundedPounds;
}
